import { Component, EventEmitter, Output } from '@angular/core';
import { SearchService } from '../../services/search.service';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import {
  BehaviorSubject,
  Subject,
  catchError,
  map,
  mergeMap,
  of,
  tap
} from 'rxjs';
import { AddressSearchFieldComponent } from '../../general/address-search-field/address-search-field.component';
import { NgIf, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-address-selector',
    templateUrl: './address-selector.component.html',
    standalone: true,
    imports: [NgIf, AddressSearchFieldComponent, ReactiveFormsModule, AsyncPipe]
})
export class AddressSelectorComponent {
  adddressSearch = new FormControl();

  @Output() addressFound = this.adddressSearch.valueChanges.pipe(
    tap((e) => console.log(e)),
    tap(() => this.searchStatus$.next('searching')),
    mergeMap((selectedAddress) => this.getFullAddress(selectedAddress)),
    tap(() => this.searchStatus$.next('idle'))
  );

  searchStatus$ = new BehaviorSubject<'idle' | 'searching'>('idle');

  constructor(private searchService: SearchService) {}

  private getFullAddress(selectedAddress: any): any {
    if (selectedAddress.place_id) {
      return this.searchService.getPlaceDetails(selectedAddress.place_id).pipe(
        map(
          (response) =>
            this.addressComponentsToSelectedAddress(
              response.address_components
            ),
          catchError(() => of(null))
        )
      );
    }
    return of(null);
  }

  private addressComponentsToSelectedAddress(
    addressComponents: any[]
  ): SelectedAddress {
    const selectedAddress: SelectedAddress = {
      address_1: '',
      address_2: '',
      city: '',
      country: '',
      county: '',
      post_code: ''
    };
    let appendedStreet = false;
    addressComponents.forEach((component) => {
      if (component.types.includes('street_number')) {
        selectedAddress.address_1 = component.long_name;
      }
      if (
        component.types.includes('route') ||
        (!appendedStreet && component.types.includes('neighborhood'))
      ) {
        selectedAddress.address_1 += ' ' + component.long_name;
        selectedAddress.address_1 = selectedAddress.address_1.trim();
        appendedStreet = true;
      }
      if (
        component.types.includes('postal_town') ||
        component.types.includes('locality')
      ) {
        selectedAddress.city = component.long_name;
      }
      if (component.types.includes('postal_code')) {
        selectedAddress.post_code = component.long_name;
      }
      if (
        component.types.includes('administrative_area_level_2') ||
        (!selectedAddress.county &&
          component.types.includes('administrative_area_level_1'))
      ) {
        selectedAddress.county = component.long_name;
      }
      if (component.types.includes('country')) {
        selectedAddress.country = component.long_name;
      }
    });
    return selectedAddress;
  }
}

interface SelectedAddress {
  address_1: string;
  address_2: string;
  city: string;
  country: string;
  county: string;
  post_code: string;
}
